import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0286d3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text--center caption" }, [
  /*#__PURE__*/_createTextVNode(" Укажите ваш e-mail и мы пришлем"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" инструкцию по смене пароля ")
], -1))
const _hoisted_2 = { class: "mt-8" }
const _hoisted_3 = { class: "mt-6 text--center" }
const _hoisted_4 = { class: "mt-2 text--center" }

import { ref, onMounted } from 'vue';
import SberId from '@/views/auth/components/SberId.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RestorePassword',
  props: {
  hasSignInError: {
    type: Boolean,
    default: false,
  },
  restoreDisabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:email', 'register', 'goToLogin', 'loginByPhone', 'submit'],
  setup(__props, { emit }) {

const props = __props;





const email = ref('');
const fieldEmail = ref();

onMounted(() => {
  setTimeout(() => fieldEmail.value.focus(), 200);
});

const updateEmail = () => emit('update:email', email.value);
const register = () => emit('register');
const goToLogin = () => emit('goToLogin');
const loginByPhone = () => emit('loginByPhone');
const submit = () => {
  if (props.restoreDisabled) {
    return;
  }
  emit('submit', email.value);
};

return (_ctx: any,_cache: any) => {
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_UiInput, {
      ref_key: "fieldEmail",
      ref: fieldEmail,
      modelValue: email.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
        updateEmail
      ],
      class: "mt-4",
      placeholder: "Email",
      type: "email",
      size: "large",
      error: __props.hasSignInError,
      onPressEnter: submit
    }, null, 8, ["modelValue", "error"]),
    _createVNode(_component_UiButton, {
      class: "button-submit mt-4",
      type: "primary",
      size: "large",
      disabled: __props.restoreDisabled,
      onClick: submit
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Отправить ")
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createElementVNode("p", {
      class: _normalizeClass(["auth-view--error text--small text--center error--text mt-2", { active: __props.hasSignInError }])
    }, " Указанный email не найден ", 2),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_UiButton, {
        class: "button-login",
        size: "large",
        onClick: loginByPhone
      }, {
        default: _withCtx(() => [
          _createTextVNode("Войти по телефону")
        ]),
        _: 1
      })
    ]),
    _createVNode(SberId, { class: "mt-4" }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_UiButton, {
        type: "link",
        size: "large",
        onClick: goToLogin
      }, {
        default: _withCtx(() => [
          _createTextVNode("На страницу вход")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_UiButton, {
        type: "link",
        size: "large",
        onClick: register
      }, {
        default: _withCtx(() => [
          _createTextVNode("Зарегистрироваться")
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})